import loadingAnimationActionTypes from "./loading-animation.types";

export const startLoading = () => ({
	type: loadingAnimationActionTypes.START_LOADING,
});

export const stopLoading = () => ({
	type: loadingAnimationActionTypes.STOP_LOADING,
});
